import { render, staticRenderFns } from "./dialog-detailconsent.vue?vue&type=template&id=5e93a948&"
import script from "./dialog-detailconsent.vue?vue&type=script&lang=js&"
export * from "./dialog-detailconsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports